import React from 'react';
import Swal from 'sweetalert2';
import useStyles from "@jumbo/vendors/sweetalert2/style";
import withReactContent from "sweetalert2-react-content";

const useSwalWrapper = () => {
    const sweetAlertStyles = useStyles();
    const {
        container,
        popup,
        title,
        closeButton,
        image,
        htmlContainer,
        confirmButton,
        cancelButton,
        footer,
    } = sweetAlertStyles;

    return React.useMemo(() => {
        const finalSwal = Swal.mixin({
            customClass: {
                container: `${container}`,
                popup: `${popup}`,
                title: `${title}`,
                closeButton: `${closeButton}`,
                image: `${image}`,
                htmlContainer: `${htmlContainer}`,
                confirmButton: `${confirmButton}`,
                cancelButton: `${cancelButton}`,
                footer: `${footer}`,
            },
            buttonsStyling: false,
        });

        return withReactContent(finalSwal);
    }, [container, popup, title, closeButton, image, htmlContainer, confirmButton, cancelButton, footer]);
};

export default useSwalWrapper;